/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {XhrHttpModule} from "@intuitionrobotics/thunderstorm/frontend";
import {Api_PermissionList, DB_Permission, PermissionsApi_Set} from "@app/app-shared/permission";
import {HttpMethod} from "@intuitionrobotics/thunderstorm";
import {dispatch_onUsersUpdated} from "@modules/UsersModule";
import {Module, PartialProperties} from "@intuitionrobotics/ts-common";

export class AppPermissionsModule_Class
    extends Module<DB_Permission> {

    constructor() {
        super("PermissionsModule");
    }

    setPermission = async (permission: PartialProperties<DB_Permission, "id">, userIds: string[]) => XhrHttpModule
        .createRequest<PermissionsApi_Set>(HttpMethod.POST, "assign-permission")
        .setJsonBody({permission, userIds})
        .setRelativeUrl("/v1/permissions/set")
        .setOnError((err) => {
            this.logError("error creating permission", err)
            dispatch_onUsersUpdated.dispatchUI()
        })
        .executeSync();

    list = async () => XhrHttpModule
        .createRequest<Api_PermissionList>(HttpMethod.GET, "list")
        .setRelativeUrl("/v1/permissions/list")
        .setOnError((err) => this.logError("error querying permissions", err))
        .executeSync();

}

export const AppPermissionsModule = new AppPermissionsModule_Class();
